// Shared presentation. All actions and data are supplied by the account-specific controller.
export default function DriverAssignedOrderCard({canDocuments=true,item,canOpenOrderDetail,navigateFromOrders,isNextDriverOrder,text,statusColors,statusLabel,serviceTypeLabel,OrderSeatBadges,driverLanguage,changeHighlights,formatDriverLocationLine,canViewRevenueStats,formatYen,isFleetManagedOrder,assignedFleetDriver,openFleetDriverAssignment,canUseFleetOrderTools,openReportModal,handleDownloadSignboardPdf,generatingSignboardOrderId,handleAddOrderToCalendar,getDriverCalendarAdded,formatDriverVehicleType}) {return (<div
                            key={`order-${item.id}`}
                            onClick={() => {
                              if (canOpenOrderDetail) {
                                navigateFromOrders(`/driver/orders/${item.id}`);
                              }
                            }}
                            className={`driver-order-card bg-card rounded-xl p-4 shadow-sm active:bg-surface ${
                              canOpenOrderDetail ? 'cursor-pointer' : 'cursor-default'
                            } ${
                              isNextDriverOrder ? 'driver-next-order-highlight' : ''
                            }`}
                            data-testid={`order-card-${item.id}`}
                            data-next-order={isNextDriverOrder ? 'true' : undefined}
                          >
                        <div className="flex justify-between items-start mb-2">
                          <div className="flex items-center gap-2">
                            <span className={`font-bold text-foreground ${
                              isNextDriverOrder ? 'driver-next-order-time' : 'text-xl'
                            }`}>
                              {item.pickup_time || '--:--'}
                            </span>
                            <span className="px-2 py-0.5 rounded-full text-xs premium-chip-success">{text.official}</span>
                            <span className={`px-2 py-0.5 rounded-full text-xs ${statusColors[item.status] || 'bg-surface'}`}>
                              {statusLabel(item.status)}
                            </span>
                            {item.trip_chat_unread && (
                              <span className="rounded-full bg-destructive px-2 py-0.5 text-xs font-bold text-destructive-foreground">
                                {text.unreadMessage}
                              </span>
                            )}
                          </div>
                          <span className="text-sm text-muted-foreground">
                            {serviceTypeLabel(item.service_type)}
                            {item.service_type === 'charter' && item.selected_hours && ` · ${item.selected_hours}h`}
                          </span>
                        </div>

                        <OrderSeatBadges order={item} language={driverLanguage} />
                        <div className="space-y-1 text-sm">
                          {changeHighlights.length > 0 && (
                            <div className="driver-order-change-highlights" aria-label={text.orderChangeUpdated}>
                              <span className="driver-change-highlight">{text.orderChangeUpdated}</span>
                              {changeHighlights.map((label) => (
                                <span key={label} className="driver-change-highlight">{label}</span>
                              ))}
                            </div>
                          )}
                          <div className="flex items-start gap-2">
                            <span className="text-success mt-0.5">●</span>
                            <span className="text-foreground">
                              {formatDriverLocationLine(
                                item.pickup_area,
                                item.pickup_location_detail || item.pickup_location,
                                item.pickup_location
                              )}
                            </span>
                          </div>
                          {(item.dropoff_location_detail || item.destination || item.dropoff_area) && (
                            <div className="flex items-start gap-2">
                              <span className="text-destructive mt-0.5">●</span>
                              <span className="text-foreground">
                                {formatDriverLocationLine(
                                  item.dropoff_area,
                                  item.dropoff_location_detail || item.destination,
                                  item.destination
                                )}
                              </span>
                            </div>
                          )}
                        </div>

                        <div className="mt-3 border-t border-border-subtle pt-3 text-sm text-muted-foreground">
                          <div className="flex items-center justify-between gap-2">
                            <span className="min-w-[120px] flex-1 truncate">
                              {item.customer_name || text.unknownCustomer}
                              {item.customer_code && <span className="ml-1 text-muted-foreground">({item.customer_code})</span>}
                            </span>
                            {canViewRevenueStats && item.driver_dispatch_price_visible && (
                              <span
                                className="driver-dispatch-price-pill"
                                data-testid="driver-order-card-dispatch-price"
                              >
                                    {text.dispatchPrice} {formatYen(item.driver_dispatch_price_amount)}
                              </span>
                            )}
                          </div>
                          {isFleetManagedOrder && (
                            <>
                              <div className="mt-3 flex items-center justify-between gap-3 border-t border-border-subtle pt-3">
                                <div className="min-w-0">
                                  <p className="text-xs font-semibold text-muted-foreground">{text.fleetAssignedDriver}</p>
                                  <p className="truncate text-sm font-bold text-foreground">
                                    {assignedFleetDriver.name || text.fleetUnassigned}
                                    {assignedFleetDriver.phone ? <span className="ml-1 font-medium text-muted-foreground">· {assignedFleetDriver.phone}</span> : null}
                                  </p>
                                  {assignedFleetDriver.vehicle ? <p className="mt-1 truncate text-xs font-medium text-primary">{text.fleetAssignedVehicle}: {assignedFleetDriver.vehicle}</p> : null}
                                </div>
                                {item.fleet_assignment_locked ? (
                                  <span className="max-w-[9.5rem] text-right text-xs font-semibold leading-5 text-muted-foreground">
                                    {text.fleetAssignmentLocked}
                                  </span>
                                ) : (
                                  <button
                                    type="button"
                                    onClick={(event) => openFleetDriverAssignment(event, item)}
                                    className="shrink-0 rounded-lg border border-primary/45 bg-primary/12 px-3 py-2 text-xs font-bold text-primary transition active:scale-[0.98]"
                                    data-testid={`fleet-assign-driver-${item.id}`}
                                  >
                                    {assignedFleetDriver.name ? text.fleetReassignDriver : text.fleetAssignDriver}
                                  </button>
                                )}
                              </div>
                              <button
                                type="button"
                                className="mt-3 w-full rounded-lg border border-primary/45 bg-primary/12 px-3 py-2.5 text-sm font-bold text-primary transition active:scale-[0.98]"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  navigateFromOrders(`/driver/orders/${item.id}`);
                                }}
                                data-testid={`fleet-order-detail-${item.id}`}
                              >
                                {text.orderDetail}
                              </button>
                            </>
                          )}
                          {canUseFleetOrderTools && (
                          <div className="driver-order-card-actions-row">
                            <div className="driver-order-card-action-buttons">
                            {/* 包车订单显示汇报按钮 */}
                            {item.service_type === 'charter' && (
                              <button
                                onClick={(e) => openReportModal(e, item)}
                                className={`driver-report-time-button ${
                                  item.reported_end_time
                                    ? 'driver-report-time-button-reported'
                                    : 'driver-report-time-button-pending'
                                }`}
                                data-testid={`report-btn-${item.id}`}
                              >
                                    {item.reported_end_time ? `${text.reportedAt} ${item.reported_end_time}` : text.reportDuration}
                              </button>
                            )}
                            {canDocuments && <button
                              onClick={(e) => handleDownloadSignboardPdf(e, item)}
                              disabled={generatingSignboardOrderId === item.id}
                              className="px-2.5 py-1 rounded text-xs font-semibold bg-primary text-primary-foreground hover:brightness-110 disabled:opacity-50"
                              data-testid={`download-signboard-pdf-${item.id}`}
                            >
                                  {generatingSignboardOrderId === item.id ? text.downloading : text.downloadPdf}
                            </button>}
                            <button
                              type="button"
                              onClick={(e) => handleAddOrderToCalendar(e, item)}
                              className={`px-2.5 py-1 rounded text-xs font-semibold border transition ${
                                getDriverCalendarAdded(item.id)
                                  ? 'bg-success/15 text-success border-success/30'
                                  : 'bg-surface text-foreground border-border-subtle hover:bg-muted'
                              }`}
                              data-testid={`add-calendar-${item.id}`}
                            >
                                  {getDriverCalendarAdded(item.id) ? text.addedToCalendar : text.addToCalendar}
                            </button>
                            </div>
                            <span className="driver-order-card-vehicle">{formatDriverVehicleType(item.vehicle_type)}</span>
                          </div>
                          )}
                        </div>
                      </div>);}
